var map = {
	"./X33-Mall_small.jpg": 828,
	"./all.svg": 829,
	"./apple-watch.png": 830,
	"./b-headphone.png": 831,
	"./coin.svg": 832,
	"./delete-btn.svg": 833,
	"./iphone-pink.png": 834,
	"./love.svg": 835,
	"./mobile-bg.jpg": 836,
	"./price-high.svg": 837,
	"./price-low.svg": 838,
	"./shopping-cart.svg": 839,
	"./star.svg": 840,
	"./x33mall-banner-cn.jpg": 841,
	"./x33mall-banner-id.jpg": 842,
	"./x33mall-banner-ms.jpg": 843,
	"./x33mall-banner.jpg": 844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;